export enum EPaymentPreference {
    Autopay = 1,
    Invoice = 2,
    VisitDataOnly = 3
}
